type Config = {
  apiUrl: string;
};

export const config: Config = {
  apiUrl: process.env.PUBLIC_API_URL || 'http://localhost:8001',
};
